import React, { useState, createRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Logo from './logo';
import Menu from './menu';
import Admin from './admin';
import AccountInfo from './AccountInfo';
import { useLocaleContext } from '../context/LocaleContext';
import request from '../utils/request';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Header = ({ locale, userName, userRights, profile }) => {
  const local = useLocaleContext();
  const {
    USERS: {
      LIST: { WELCOME }
    }
  } = local === 'en-US' ? EN : FR;
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [userDealership, setUserDealership] = useState();
  const ref = createRef();
  const onClick = (e, className) => {
    e.preventDefault();
    ref.current.className = className;
  };

  const getUsersDealershipName = async () => {
    request.get(`/dealerships`).then(response => {
      if (response && response.status === 200) {
        if (
          response.data &&
          response.data.rows &&
          response.data.rows.length &&
          profile && profile.channels &&
          profile.channels.some(channel => channel.id === 17) // when channel is dealer
        ) {
          const dealershipName = response.data.rows.find(
            dealership => dealership.id === profile.dealership
          );
          if (dealershipName) setUserDealership(dealershipName.name);
        }
      }
    });
  };

  // Getting the List of dealership from contentful
  useEffect(() => {
    getUsersDealershipName();
  }, []);

  return (
    <>
      <div className="container 85%"></div>
      <header id="header">
        <div className="header-main">
          <div className="nav-main">
            <div className="nav-inner">
              <ul>
                {userRights && (
                  <Admin userRights={userRights} profile={profile} />
                )}
              </ul>

              {userName && (
                <Menu
                  locale={locale}
                  userName={userName}
                  userRights={userRights}
                  profile={profile}
                />
              )}
            </div>
          </div>
        </div>
        <div className="header-bottom-main">
          <div className="header-bottom-container">
            <div className="header-bottom-inner">
              <Logo locale={locale} userRights={userRights} />
              {userName && (
                <div className="header-bottom-username-main">
                  <span className="header-bottom-welcome-label">
                    {WELCOME},
                  </span>
                  <button
                    style={{
                      background: 'transparent',
                      border: 0,
                      padding: 0,
                      fontSize: '16px'
                    }}
                    type="button"
                    className="header-bottom-username"
                    onClick={() => setShowAccountInfo(true)}
                  >
                    {userName}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {userName && (
        <>
          <a
            href="#navPanelToggle"
            className="navPanelToggle"
            onClick={e => onClick(e, 'visible')}
          >
            <span className="fa fa-bars"></span>
          </a>

          <div id="navPanel" ref={ref}>
            <Menu locale={locale} userName={userName} userRights={userRights} />
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              href="#navPanel"
              className="close"
              onClick={e => onClick(e, '')}
            />
          </div>
        </>
      )}

      <section id="banner" />
      {showAccountInfo && (
        <AccountInfo
          dealership={userDealership}
          onClose={() => {
            setShowAccountInfo(false);
          }}
        />
      )}
    </>
  );
};

Header.propTypes = {
  locale: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool
  })
};

Header.defaultProps = {
  userRights: null
};

export default Header;
